export class Art {
  id: number = 0;
  artName?: string = "";
  city: string = "";

  // Stupid backend naming sense 
  // (different api provides data in different keys for same )
  imageUrl: string = "";
  artUploadUrl: string = "";

  // Stupid backend naming sense
  artThumbnailUploadUrl: string = "";
  artThumbnailUrl:string = "";

  likeUnlikeStatus: boolean = false;
  watermark: boolean = false;
  price: string = "";
  subscribed?: boolean
  description?: string = "";
  nameAsSignature?:boolean;
  // Artist Details
  artistId: number = 0;
  artistUserName: string = '';
  artistName?: string = "";
  signature: string = "";
  profilePic?: string;
  
  constructor(data?: Partial<Art>) {
    Object.assign(this, data);
  }

  setLike(value:boolean): Art {
    this.likeUnlikeStatus = value;
    return this;
  }
}



export class ArtList extends Array<Art> {

  constructor(...arts: (Partial<Art> & { id:number }[])) {
    const adaptedItems = arts.map((el:any) => ArtAdaptor.adapt(el));
    super(...adaptedItems);
  }

  removeArt(...artIDs:number[]): void {
    this.splice(0, this.length, ...this.filter(art => !artIDs.includes(art.id)));
  }

  /**
   * Override push to transform or validate Art objects before adding them
   */
  override push(...items: (any & { id: number })[]): number {
    const adaptedItems = items.map((el:Partial<Art>) => ArtAdaptor.adapt(el));
    return super.push(...adaptedItems);
  }
}




export class ArtAdaptor {
  static adapt(apiData: any): Art {
    return new Art({
      id: apiData?.id || apiData.artDetailId, // Ensure id is always present
      signature: apiData.signature,
      artName: apiData.artName,
      city: apiData.city,

      // Stupid Backend
      imageUrl: apiData?.imageUrl || apiData?.artUploadUrl,
      artUploadUrl:apiData?.artUploadUrl,
      artThumbnailUrl: apiData?.artThumbnailUrl,
      artThumbnailUploadUrl: apiData?.artThumbnailUploadUrl,

      
      likeUnlikeStatus: apiData.likeUnlikeStatus,
      watermark: apiData.watermark,
      price: apiData?.price || apiData?.artPrice,
      subscribed:apiData?.subscribed || null,
      artistId: apiData.artistId ?? 0, // Ensure artistId is always a number
      artistName: apiData.artistName,
      profilePic: apiData?.artistProfilePic || apiData?.profilePic || "",
      description: apiData?.description || "",
      artistUserName: apiData?.artistUserName || apiData?.artistUserName || "",
      nameAsSignature:apiData?.nameAsSignature
    });
  }
}

